/**
 * Winwin — login bridge
 */
(function () {
  function showErrors(box, errors) {
    if (!box) return;
    var list = (errors || []).map(function (e) {
      return typeof e === 'string' ? e : (e && e.text) || '';
    }).filter(Boolean);
    if (!list.length) {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }
    box.hidden = false;
    box.innerHTML = '<ul>' + list.map(function (t) {
      return '<li>' + String(t).replace(/</g, '&lt;') + '</li>';
    }).join('') + '</ul>';
  }

  function nextUrl() {
    var params = new URLSearchParams(window.location.search);
    var next = params.get('next') || '/pages/account';
    if (next.charAt(0) !== '/') next = '/pages/account';
    return next;
  }

  async function init(root) {
    var form = root.querySelector('[data-login-form]');
    if (!form || !window.WinwinApi) return;
    var apiBase = window.WinwinApi.baseFrom(root);
    var errorBox = root.querySelector('[data-login-errors]');
    var submitBtn = form.querySelector('[type="submit"]');

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      showErrors(errorBox, []);
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.label = submitBtn.dataset.label || submitBtn.textContent;
        submitBtn.textContent = 'Signing in…';
      }
      var fd = new FormData(form);
      try {
        var res = await window.WinwinApi.request(apiBase, '/login', {
          method: 'POST',
          body: {
            email: String(fd.get('email') || '').trim(),
            password: String(fd.get('password') || '')
          }
        });
        if (!res.ok || !res.data || res.data.success !== true) {
          showErrors(errorBox, (res.data && res.data.errors) || [{ text: 'Invalid email or password.' }]);
          return;
        }
        if (res.data.token && window.WinwinApi.setToken) {
          window.WinwinApi.setToken(res.data.token);
        }
        window.location.href = nextUrl();
      } catch (err) {
        console.error('[winwin login]', err);
        showErrors(errorBox, [{ text: 'Network error. Please try again.' }]);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.label || 'Log in';
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-login-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
